module.exports = __webpack_public_path__ + "static/media/help_map.66556623.svg";